import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StaticService {

  private info = new BehaviorSubject(<any>null);

  constructor(private http: HttpClient) { }

  getInfo(): Observable<any> {
    return this.info.asObservable();
  }

  updateInfo(info: any) {
    this.info.next(info);
  }

  getFaqCategory() {
    const url = `${environment.apiUrl}common/faq/category/get-list`;
    return this.http.get(url);
  }

  getContactInfo() {
    const url = `${environment.apiUrl}admin/contact-info/get-details`;
    return this.http.get(url);
  }

  getLocation() {
    const url = `${environment.apiUrl}common/location/get-list`;
    return this.http.get(url);
  }

  getFaq(categoryId: string) {
    const url = `${environment.apiUrl}common/faq/get-all?categoryId=${categoryId}`;
    return this.http.get(url);
  }

  getStaticPageData(title: string) {
    const url = `${environment.apiUrl}common/static/page/getByTitle?title=${title}`;
    return this.http.get(url);
  }
  getMostVisitedProperty(paylod:any) {
    const url = `${environment.apiUrl}user/property/most-visited-properties?showImages=${true}`;
    return this.http.get(url);
  }

  getGuestMostVisitedProperty(paylod:any) {
    const url = `${environment.apiUrl}user/property/guest/most-visited-properties?showImages=${true}`;
    
    return this.http.get(url);
  }
  updateVisitCount(propertyId: string) {
    const url = `${environment.apiUrl}user/property/visit-count/${propertyId}`;
    return this.http.post(url, {});
  }
  fetchGooglePlace(query:string){
    const url = `${environment.apiUrl}user/google/fetchPlaces?input=${query}`;
    return this.http.get(url);
  }
}
